import { site } from "../constants/site";

export function buildWhatsAppUrl(service?: string) {
  // const message = service
  //   ? `Hello Skand Tech Hub, I want to discuss ${service}. Please share the next steps.`
  //   : 'Hello Skand Tech Hub, I want to discuss a technology project. Please share the next steps.';

  const message = service
    ? `Hello Skand Tech Hub,

I'm interested in your ${service} services and would like to discuss my requirements.

I'd appreciate the opportunity to learn more about your process and explore how your team can help.

Please let me know the next steps or a convenient time to connect.

Looking forward to hearing from you.`
    : `Hello Skand Tech Hub,

I'm looking for a reliable partner to help build my next digital product and would like to discuss my requirements.

I'd appreciate the opportunity to learn more about your process and explore how your team can help bring my ideas to life.

Please let me know the next steps or a convenient time to connect.

Looking forward to hearing from you.`;

  return `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(message)}`;
}

export function openWhatsApp(service?: string) {
  window.open(buildWhatsAppUrl(service), "_blank", "noopener,noreferrer");
}
